// kavita-search-bottom-sheet-stack
// Theme's QuickBuyPopover/Drawer (in theme.js) registers a one-shot transitionend listener on
// `openable-element:close` that wipes `innerHTML = ""`. Inside SearchTap, a stale/late transitionend
// can fire on the *open* transition of a later open (or the close listener races with the next
// open's _load), leaving the 2nd ATC with the [open] attribute but empty children -> a collapsed,
// invisible bottom sheet.
// Neutralize _onClose: `_load()` does `replaceChildren(...)` on every open anyway, so memory stays
// bounded and content stays fresh per open.
(function patchQuickBuyOnClose() {
  if (!window.customElements || !customElements.whenDefined) return;
  ['quick-buy-popover', 'quick-buy-drawer'].forEach(function (tag) {
    customElements.whenDefined(tag).then(function (Ctor) {
      if (Ctor && Ctor.prototype && Ctor.prototype._onClose && !Ctor.prototype.__kavitaSearchSheetPatched) {
        Ctor.prototype._onClose = function () {};
        Ctor.prototype.__kavitaSearchSheetPatched = true;
      }
    });
  });
})();
